import { render, staticRenderFns } from "./ContactTypesPropertiesModal.vue?vue&type=template&id=3a2a6762&"
import script from "./ContactTypesPropertiesModal.vue?vue&type=script&lang=js&"
export * from "./ContactTypesPropertiesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports